import React, { forwardRef } from 'react';
import { StyledCheckbox, StyledCheckboxLabel, Wrapper } from './styles';
import { getRandomString } from '@src/common';

type CheckboxProps = Omit<JSX.IntrinsicElements['input'], 'type' | 'ref'> & {
  label?: string;
  accentColor?: string;
};

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (props: CheckboxProps, inputRef: React.Ref<HTMLInputElement>) => {
    const { label, id = getRandomString(5), accentColor, ...rest } = props;

    return (
      <Wrapper>
        <StyledCheckbox id={id} type='checkbox' ref={inputRef} $accentColor={accentColor} {...rest} />

        {label ? <StyledCheckboxLabel htmlFor={id}>{label}</StyledCheckboxLabel> : null}
      </Wrapper>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
